/// <amd-module name="Wit/Common/WorkItemControls/NodeTreeItemProvider" />
import { IObservable, IObservableArrayEventArgs, IReadonlyObservableArray, ObservableArrayAction, ObservableCollection } from "VSS/Core/Observable";
import { IListBoxItem } from "VSSUI/ListBox";
import { IItemProvider } from "VSSUI/Utilities/Provider";
import { WorkItemClassificationNode } from "Wit/Clients/Wit/Contracts/WorkItemTracking";

export type INodeTreeItem = WorkItemClassificationNode | { [key: string]: never };

/**
 * Manage a combined list of suggestions and full nodes
 */
export class NodeTreeItemProvider
    implements IItemProvider<IListBoxItem<INodeTreeItem>>, IObservable<IObservableArrayEventArgs<IListBoxItem<INodeTreeItem>>, ObservableArrayAction>
{
    private itemCollection: ObservableCollection<IListBoxItem<INodeTreeItem>>;

    public constructor(
        suggestionItems: IReadonlyObservableArray<IListBoxItem<INodeTreeItem>>,
        listItems: IReadonlyObservableArray<IListBoxItem<INodeTreeItem>>
    ) {
        this.itemCollection = new ObservableCollection<IListBoxItem<INodeTreeItem>>();
        this.itemCollection.push(suggestionItems);
        this.itemCollection.push(listItems);
    }

    /**
     * Get the length of the listItems array.
     */
    public get length(): number {
        return this.itemCollection.length;
    }

    /**
     * Get the interal array of listItems.
     */
    public get value(): IListBoxItem<INodeTreeItem>[] {
        return this.itemCollection.value;
    }

    /**
     * Subscribe to changes in the underlying set of items.
     * @param observer the delegate to be called when there are updates.
     * @param action the action on the set to observe.
     */
    public subscribe(
        observer: (value: IObservableArrayEventArgs<IListBoxItem<INodeTreeItem>>, action?: ObservableArrayAction) => void,
        action?: ObservableArrayAction
    ): (value: IObservableArrayEventArgs<IListBoxItem<INodeTreeItem>>, action?: ObservableArrayAction) => void {
        return this.itemCollection.subscribe(observer, action);
    }

    /**
     * Unsubscribe from changes in the underlying set of items.
     * @param observer the delegate that was used to subscribe.
     * @param action the action that was used to subsribe.
     */
    public unsubscribe(
        observer: (value: IObservableArrayEventArgs<IListBoxItem<INodeTreeItem>>, action?: ObservableArrayAction) => void,
        action?: ObservableArrayAction
    ): void {
        return this.itemCollection.unsubscribe(observer, action);
    }
}
